__turbopack_context__.v({
  "container": "MatchingEventBanners-module__TGzWHG__container",
  "modalTitle": "MatchingEventBanners-module__TGzWHG__modalTitle",
  "open": "MatchingEventBanners-module__TGzWHG__open",
});
